var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockCheckFill(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 6.333v-2a3.333 3.333 0 016.666 0v2",
    stroke: "#121318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 5.5c-.828 0-1.5.634-1.5 1.417v5.666C2 13.366 2.672 14 3.5 14h9c.828 0 1.5-.634 1.5-1.417V6.917c0-.783-.672-1.417-1.5-1.417h-9zm7.155 3.388a.667.667 0 00-.943-.943L7.517 10.14l-.862-.861a.667.667 0 00-.943.942l1.333 1.334c.26.26.683.26.943 0l2.667-2.667z",
    fill: "#121318"
  })));
}

export default SvgLockCheckFill;